import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const selectorRef = useRef(null);

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Español' },
    { code: 'zh', name: '中文' },
    { code: 'hi', name: 'हिन्दी' },
    { code: 'fr', name: 'Français' },
    { code: 'ar', name: 'العربية' },
    { code: 'bn', name: 'বাংলা' },
    { code: 'pt', name: 'Português' },
    { code: 'ru', name: 'Русский' },
    { code: 'de', name: 'Deutsch' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getCurrentLanguage = () => {
    return languages.find(lang => lang.code === i18n.language)?.name || 'English';
  };

  const handleLanguageChange = (code) => {
    try {
      window.localStorage.setItem('fm_lang', code);
    } catch (e) {
      // ignore storage errors
    }
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className="language-selector" ref={selectorRef}>
      <div 
        className={`language-select-button ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{getCurrentLanguage()}</span>
        <span className="arrow">▼</span>
      </div>
      
      {isOpen && (
        <>
          <div className="language-overlay" onClick={() => setIsOpen(false)} />
          <div className="language-dropdown">
            {languages.map(lang => (
              <div
                key={lang.code}
                className={`language-option ${i18n.language === lang.code ? 'selected' : ''}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                {lang.name}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector; 